/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_NoneInputs */

const vi_online_price_none = /** @type {(inputs: Online_Price_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa đặt`)
};

/**

* @param {Online_Price_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_none = /** @type {((inputs?: Online_Price_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_none(inputs)
});